import { z } from 'zod'

export function validateEmail(email: string) {
   const emailSchema = z.string().email()
   const result = emailSchema.safeParse(email)
   if (!result.success) {
      return false
   }
   return true
}

/**
 * @param orgFields Pass whole fieldset that includes `website`, so that object is mutated
 */
export function formatWebsiteFieldValue(orgFields: { website?: string }) {
   orgFields.website = formatWebsiteUrl(orgFields.website)
}

/**
 * Prepends an assumed https protocol if URL would otherwise be valid (eg. 'example.com' -> 'https://example.com')
 * @param websiteUrl url of the website
 * @returns formatted websiteUrl
 */
export const formatWebsiteUrl = (websiteUrl: string | undefined) => {
   if (websiteUrl && !/^https?:\/\/.*$/.test(websiteUrl) && /^.+\..+/.test(websiteUrl)) {
      return `https://${websiteUrl}`
   }
   return websiteUrl
}
